import React, { useEffect, useState } from "react";
import {
  Button,
  Switch,
  Card,
  TimePicker,
  Divider,
  Row,
  Col, 
} from "antd";

import { EditOutlined,  PlusOutlined } from "@ant-design/icons";
import "./styles.scss";
import DatePicker from "react-multi-date-picker"
import moment from "moment"
import { v4 as uuidv4 } from 'uuid';
import SettingsService from "../../../services/SettingsService";


const Dine = ({dineTimeRest=[],holidayRest=[],isDine,showConfirm,disableDine,adminRestaurant,type, resSettings}) => {
  const [dineTime, setDineTime] = useState([{

    day_start_time:"",
    day_end_time: "",
    day_type: "Monday",
    id: uuidv4()

    
  }]);
  const [holidayDates, setHolidayDates] = useState([])
  const [allDines, setAllDines] = useState([])
  const [allHolidays, setAllHolidays] = useState([])
  const [holidays, setHolidays] = useState([])
  const [showDatepicker, setShowDatePicker] = useState(false)
  const [selectedDay, setSelectedDay] = useState("Monday")

  const handleClick = () => {
    setShowDatePicker(true)
  }

  const updateHolidayFormat = (holiday)=>{
    const allHolidaylist = holiday.map(item =>{
      
      const d = new Date(item.date);
     const date = `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
  
   const obj ={
      date: moment(date).format('YYYY-MM-DD'),
      month: item.month,
      day_type: item.day_type,
      id:item.id

   }
   return obj
   })
   return allHolidaylist
  }
  useEffect(()=>{
    if(dineTimeRest?.length >0)
      {
    setDineTime(dineTimeRest?.filter(item => item.day === selectedDay))
    setAllDines(dineTimeRest)
      }else
      setAllDines(dineTime)
  if(holidayRest?.length>0)
    {
    setHolidayDates(holidayRest.map(item => new Date(item.date)))
    
    setAllHolidays(updateHolidayFormat(holidayRest))
    }
  },[dineTimeRest,holidayRest])
  useEffect(() => { const listHoliday = holidayDates.map((element) => {
    var d = new Date(element);
    return `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
  });
  setHolidays(listHoliday)
 }, [holidayDates])
  const onTemporarilyOff = (checked, option) => {
    console.log(`switch to ${checked} , ${option}`);
  };
  const daysInWeek = [{ id: 1, name: "Mo",value:"Monday" }, { id: 2, name: "Tu",value:"Tuesday" }, { id: 3, name: "We",value:"Wednesday" }, { id: 4, name: "Th" ,value:"Thursday"}, { id: 5, name: "Fr",value:"Friday" }, { id: 6, name: "Sa", value:"Saturday" }, { id: 7, name: "Su" ,value:"Sunday"}]
 
  const onChangeTime = async(time, timeString,itemUpdate,typeChange) => {
    const dineDteUpdate = allDines.map( item=> {
      if(item.id === itemUpdate.id)
      {
        const obj = {day_start_time: typeChange=== "to"? timeString:item.day_start_time,
        day_end_time: typeChange=== "from"? timeString:item.day_end_time,
        id:item.id,
        day: selectedDay,
        isExisting : item?.isExisting

        }
        if(type === "to" && item.day_end_time?.length >1 ){
            const payload ={
              day: selectedDay,
              day_start_time: timeString+":00",
              day_end_time: item.day_end_time?.length>6 ? item.day_end_time : item.day_end_time+":00",
              day_type: type
            }
            if(itemUpdate?.isExisting)
              {
            const updateOH = SettingsService.updateOperatingHours(adminRestaurant,payload,itemUpdate.id)
              }
            else
            {
              const addOH = SettingsService.addOperatingHours(adminRestaurant,payload)
              console.log("ayatt",addOH)

            }

        }
        else if(typeChange === "from" && item.day_start_time?.length >1 ){
          const payload ={
            day: selectedDay,
            day_start_time: item.day_start_time?.length > 6 ? item.day_start_time: item.day_start_time+":00",
            day_end_time: timeString+":00",
            day_type: type
          }
          if(itemUpdate?.isExisting)
            {
          const updateOH = SettingsService.updateOperatingHours(adminRestaurant,payload,itemUpdate.id)
            }
          else
          {
            const addOH = SettingsService.addOperatingHours(adminRestaurant,payload)
            console.log("ayatt",addOH)

          }
        }
        return obj;
      }else
      return item
    })
    setAllDines(dineDteUpdate)
    setDineTime(dineDteUpdate.filter(item=> item.day === selectedDay))
  };
  const addHours = () => {
    const obj = {
      day_start_time: null,
      day_end_time: null,
      id: uuidv4(),
      day: selectedDay,
    }
    setDineTime([...dineTime, obj])
    setAllDines([...allDines, obj])

  }

  const addHoliday = async(value)=>{
    
    const formattedvalue = value.map((element) => {
      var d = new Date(element);
      return `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
    });
    const lastItem = formattedvalue[formattedvalue.length - 1]
    const payload ={
       date: moment(lastItem).format('YYYY-MM-DD'),
       month: moment(lastItem).format('MMMM'),
       day_type: type
    }
    setHolidayDates(value)
    if(allHolidays.find(item=> item.date === payload.date))
      {
        const itemToDel = allHolidays.find(item=> item.date === payload.date)
        const addHoliday = await SettingsService.deleteHolidays(adminRestaurant,itemToDel?.id)
        setAllHolidays(allHolidays.filter(item=> item.id !== itemToDel?.id))
      }
      else
      {
    const addHoliday = await SettingsService.createHolidays(adminRestaurant,payload)
    setAllHolidays([...allHolidays,...updateHolidayFormat(addHoliday)])
      }
  }

  const updateDaySelection =(item) =>{
    if(!disableDine){
      setSelectedDay(item.value)
      const filterbyDay = allDines.filter(dines=> dines.day == item.value)
      setDineTime(filterbyDay)
    }
  }
 
  return (
    
            <Card className={"card-qr"}>
              <div className="qr-card-container">
                <div style={{ textAlign: "start", width: "100%" }}>
                  <div >
                  <div className="flex space-between flex-wrap">
                      <div style={{ color: "#C32340", fontWeight: "bold" }}>
                      {isDine ? "Online Ordering" :"Dine-in/Takeout"}
                      </div>
                      {isDine && <>
                      <div className="flex space-between">
                        <div className="mr-1">Use same as Dine-in </div>
                          <Button type="text" className="mr-1" danger={resSettings.use_dine_in_hours} onClick={()=>showConfirm(true)} style={{ textDecoration: resSettings.use_dine_in_hours ? "underline" : "underline"}}><div>Yes</div></Button>
                          <Button  type="text" danger={!resSettings.use_dine_in_hours} onClick={()=>showConfirm(false)} style={{ textDecoration: resSettings.use_dine_in_hours ? "underline" : "underline"}}><div>No</div></Button>
                      </div>
                      <div>
                        <span style={{ color: "#3A3A3A", opacity: 0.7 }}>
                          Turn off Temporarily:
                        </span>
                        <Switch
                          style={{ marginLeft: 12 }}
                          onChange={(value) => onTemporarilyOff(value, "DineIn")}
                        />
                      </div>
                      </>}
                    </div>
                    <Divider />
                  </div>
                  {disableDine && <div style={{ fontWeight: 600}}>Currently using Dine-in / Takeout hours</div>}
                  <Row className={disableDine ? "disabled-dine" : ""}>
                    <Col>
                      <div className="flex flex-wrap" style={{ marginTop: 16 }}>
                        <div
                          style={{
                            color: "#3A3A3A",
                            opacity: 0.7,
                            marginRight: 16,
                          }}
                        >
                          Days Of Operation:
                        </div>
                        <div>
                          <div className="time-slots">
                            {daysInWeek.map(item =>
                              <div className={selectedDay===item.value?"selected-day time-slots days":"time-slots days"} onClick={()=>updateDaySelection(item)}>
                                {item.name}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex" style={{ marginTop: 16 }}>
                        <div
                          style={{
                            color: "#3A3A3A",
                            opacity: 0.7,
                            marginRight: 16,
                          }}
                        >
                          Operational Slots:
                        </div>
                        <div>
                        {/* use12Hours format="h:mm a" */}
                          {dineTime.map(item =>
                            <div className="time-slots"><TimePicker format="HH:mm"  value={item.day_start_time && moment(item.day_start_time, 'HH:mm')} className="picker-time"  onChange={(time,timeString)=>onChangeTime(time,timeString,item,"to")} disabled={disableDine} /> to
                              <TimePicker format="HH:mm" value={item.day_end_time && moment(item.day_end_time, 'HH:mm')} className="picker-time"  onChange={(time,timeString)=>onChangeTime(time,timeString,item,"from")} disabled={disableDine}/></div>
                          )}
                          <Button type="link" onClick={() => addHours()} disabled={disableDine}>
                            <span style={{ textDecoration: "underline" }}>
                              Add Slot
                            </span>
                            <span
                              className="circle-plus"
                              style={{ marginLeft: 12 }}
                            >
                              <PlusOutlined
                                style={{ fontSize: "12px", color: "white" }}
                              />
                            </span>
                          </Button>
                        </div>

                      </div>
                    </Col>
                    <Col>
                      <Divider type="vertical" />
                    </Col>
                    <Col style={{width:"42%"}}>
                      <div className="flex" style={{ marginTop: 16 }}>
                        <div
                          style={{
                            color: "#3A3A3A",
                            opacity: 0.7,
                            marginRight: 16,
                            width:"156px"
                          }}
                        >
                          Holidays in {new Date().getFullYear()}:
                        </div>
                        <div>
                        <Row className="flex">
                          {holidays.map((item,index) =>
                            <Col className="time-slots" key={index}>{moment(item).format('MM/DD')+","}&nbsp;</Col>
                          )}
                          </Row>

                          {showDatepicker ?
                            <DatePicker
                              multiple
                              value={holidayDates}
                              onChange={(value)=> addHoliday(value)}
                              onClose={() => setShowDatePicker(false)}
                              disabled={disableDine}
                            />
                            // <></>
                            :
                            <Button type="link" onClick={() => handleClick()}
                            disabled={disableDine}
                            >
                              <span style={{ textDecoration: "underline" }}>
                                Edit Dates
                              </span>
                              <span

                                style={{ marginLeft: 12 }}
                              >
                                <EditOutlined
                                  style={{ fontSize: "12px", color: "red" }}
                                />

                              </span>
                            </Button>
                          }
                        </div>

                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Card>
            
  );
};


export default Dine;
